import { ProductVariantType, CheckoutPreviewType } from './types'
import OrderCart from './orderCart'

export default class OrderSummary {
  summaryRowModel: HTMLElement

  initialize(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this

    this.summaryRowModel = <HTMLElement>document.querySelector('.elOrderSummary tbody tr')?.cloneNode(true)
    // Clean up order summary
    // NOTE: This could also be done in rendering process to avoid screen flickering
    document.querySelectorAll('.elOrderSummary').forEach(function (orderSummary) {
      orderSummary.querySelectorAll('tbody tr').forEach(function (el) {
        el.remove()
      })
      self.setTotal(orderSummary, '')
    })
  }

  renderSummary(orderCart: OrderCart): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this
    // Update OrderSummary.
    document.querySelectorAll('.elOrderSummary').forEach(function (orderSummary) {
      const useCheckoutPreview = orderSummary.querySelector('.elOrderSummaryTaxTotal')
      if (useCheckoutPreview) {
        self.renderSummaryWithCheckoutPreview(orderCart, orderSummary)
        return
      }

      orderSummary.querySelectorAll('tr[data-product-variant-id]').forEach((row: HTMLElement) => {
        const productId = row.getAttribute('data-product-variant-id')
        const product = orderCart.productVariants.find((product) => product.id == productId)

        if (product) {
          self.addProductVariant(row, product)
        } else {
          self.removeProductVariant(row)
        }
      })

      orderCart.productVariants.forEach(function (productVariant) {
        const elementSummaryRow = orderSummary.querySelector(`tr[data-product-variant-id="${productVariant.id}"]`)
        if (!elementSummaryRow) {
          const clonedRow = <HTMLElement>self.summaryRowModel.cloneNode(true)
          self.addProductVariant(clonedRow, productVariant)
          orderSummary.querySelector('table tbody').appendChild(clonedRow)
        }
      })

      // Render Total
      const currency = orderCart.productVariants.length > 0 ? orderCart.productVariants[0].currency : '$'
      const totalText = currency + (orderCart.totalCents() / 100.0).toFixed(2)
      self.setTotal(orderSummary, totalText)
    })
  }

  private renderSummaryWithCheckoutPreview(orderCart: OrderCart, orderSummary: Element) {
    const lineItems = orderCart.productVariants.map(({ quantity, priceId }) => ({ quantity, price_id: priceId }))
    const couponCodes = [orderCart.couponCode].filter(Boolean)
    const billingAddress = { street: "", street2: "", city: "", postalCode: "", region: "", country: "" }
    const deliveryAddress = { street: "", street2: "", city: "", postalCode: "", region: "", country: "" }

    fetch(`${window.location.origin}${window.location.pathname}/order_preview`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ order: {
        line_items: lineItems,
        coupon_codes: couponCodes,
        billing_address: billingAddress,
        delivery_address: deliveryAddress
      }})
    })
      .then((resp) => resp.json())
      .then((json) => {
        if (json.error) throw Error(json.error)
        this.setSummaryPrices(orderSummary, json, orderCart.productVariants[0]?.currency)
      })
      .catch((error) => {
        console.error(error)
        alert(`Oops. Something went wrong. ${error}`)
      })
  }

  private addProductVariant(row: HTMLElement, productVariant: ProductVariantType): void {
    row.setAttribute('data-product-variant-id', productVariant.id)
    row.querySelector('td.elOrderSummaryItem').innerHTML = productVariant.name
    row.querySelector('td.elOrderSummaryQuantity').innerHTML = String(productVariant.quantity)
    const productVariantsPrice = productVariant.priceCents / 100.0
    row.querySelector('td.elOrderSummaryPrice').innerHTML = productVariant.currency + productVariantsPrice.toFixed(2)
  }

  private removeProductVariant(row: HTMLElement): void {
    row.remove()
  }

  private setTotal(orderSummary, text): void {
    orderSummary.querySelectorAll('tfoot .elOrderSummaryPrice').forEach(function (el) {
      el.textContent = text
    })
  }

  private setSummaryPrices(orderSummary: Element, checkoutPreview: CheckoutPreviewType, currency?: string) {
    orderSummary.querySelector('tfoot .elOrderSummaryTotal .elOrderSummaryPrice').textContent = this.formatPrice(
      checkoutPreview.total,
      currency
    )
    orderSummary.querySelector('tfoot .elOrderSummarySubTotal .elOrderSummaryPrice').textContent = this.formatPrice(
      checkoutPreview.subtotalAmount,
      currency
    )
    orderSummary.querySelector('tfoot .elOrderSummaryTaxTotal .elOrderSummaryPrice').textContent = this.formatPrice(
      checkoutPreview.taxAmount,
      currency
    )
    orderSummary.querySelector(
      'tfoot .elOrderSummaryShippingTotal .elOrderSummaryPrice'
    ).textContent = this.formatPrice(checkoutPreview.shippingAmount, currency)
    orderSummary.querySelector(
      'tfoot .elOrderSummaryDiscountTotal .elOrderSummaryPrice'
    ).textContent = this.formatPrice(checkoutPreview.discountsAmount * -1, currency)
  }

  private formatPrice(price: number, currency?: string) {
    return [price < 0 ? '-' : '', currency, Math.abs(price).toFixed(2)].filter(Boolean).join('')
  }
}
